<div class="loader-container">
    <ng-lottie *ngIf="hasAnimation" [options]="options" class="lottie-loader" (animationCreated)="animationCreated($event)" />
</div>